export const CARD_WIDTH = 270;
export const CARD_WIDTH_FULL_WIDTH = '100%';
export const TO_PLAN_DRAWER_WIDTH = 340;
export const ENTITY_MENU_WIDTH = 150;
export const TO_PLAN_DRAWER_HEIGHT = 96;
export const MULTIDRAG_OVERLAY_WIDTH = 90;
export const TIME_BAR_ITEM_WIDTH = 74;
